var map = {
	"./Authentication/routes": 7569,
	"./Banks/routes": 5508,
	"./Budgets/routes": 40,
	"./BudgetsFND/routes": 3822,
	"./Bussines/routes": 4335,
	"./Clients/routes": 3563,
	"./Dashboard/routes": 1660,
	"./Impimur/routes": 8629,
	"./Inventory/routes": 1360,
	"./Invoices/routes": 3763,
	"./Items/routes": 9486,
	"./Logistic/routes": 2268,
	"./NotFound/routes": 3046,
	"./PaymentsMethods/routes": 1724,
	"./Pdf/routes": 4595,
	"./ProForms/routes": 2018,
	"./PubliApp/routes": 7074,
	"./Purchases/routes": 3419,
	"./User/routes": 2464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8506;